import { ConsentServiceEntityTypeIds, ConsentTypeIds } from "@/types/consents";
import { $api } from "@/services/api";
import type { ConsentFormRequest, ConsentForm } from "@/types/consents";
import type { ApplicantVM, ApplicantFormVM } from "@/types/applicant";
import type { Ref } from "vue";

export default function useConsents(entityId: Ref<number>) {
  async function addConsent(
    userId: string,
    consentId: number | null,
    consentTypeId: number,
    consent: boolean,
    currentApplicant: ApplicantVM | ApplicantFormVM,
    entityTypeId: undefined | number = ConsentServiceEntityTypeIds.Application
  ) {
    const request = {
      id: consentId || null,
      consentTypeId: consentTypeId,
      consentGiven: consent,
      personId: currentApplicant?.id || 0,
      entityId: entityId.value,
      entityTypeId: entityTypeId,
      userId: userId || currentApplicant?.userId || undefined,
    } as ConsentFormRequest;

    if (request.id && request?.id > 0) {
      await $api.consents.updateConsent(request);
    } else {
      await $api.consents.addConsent(request);
    }
  }

  function getConsent(consents: ConsentForm[], consentTypeId: number) {
    return (consents || [])?.find(
      (q: ConsentForm) => q.consentTypeId === consentTypeId
    );
  }

  async function addOrUpdateConsentAsync(request: ConsentFormRequest) {
    let response;

    if (request.id && request?.id > 0) {
      response = await $api.consents.updateConsent(request);
    } else {
      response = await $api.consents.addConsent(request);
    }

    return {
      success: response.id && response.id > 0,
      results: response,
    };
  }

  async function addParentAttestationConsentAsync(
    consentId: number,
    consentTypeId: number,
    consentGiven: boolean,
    person: ApplicantVM | ApplicantFormVM,
    userId: string,
    entityTypeId?: number | undefined
  ) {
    // To support draws AND application
    const parentAttestationConsentForm = {
      id: consentId || 0,
      consentTypeId: consentTypeId || ConsentTypeIds.PARENT_ATTESTATION,
      consentGiven: consentGiven,
      personId: person.id,
      entityId: entityId.value,
      userId: userId || person.userId || undefined,
      entityTypeId: entityTypeId || ConsentServiceEntityTypeIds.Application,
    } as ConsentFormRequest;

    const response = await addOrUpdateConsentAsync(
      parentAttestationConsentForm
    );
    return response;
  }

  return {
    addConsent,
    addParentAttestationConsentAsync,
    getConsent,
  };
}
